import { createSelector } from 'reselect';

const selectCache = (state: any) => state.userCache;

export const selectUsersLoading = createSelector(
  selectCache,
  (cache: any) => cache.loading
);

export const selectUsers = createSelector(
  selectCache,
  (cache: any) => cache.users
);

export const selectUser = createSelector(
  selectCache,
  (cache: any) => cache.user
);
export const selectApiKeys = createSelector(
  selectCache,
  (cache: any) => cache.apiKeys
);

export const selectProfileUpdatingFlag = createSelector(
  selectCache,
  (cache: any) => cache.profileUpdatingFlag
);

export const selectContactSupportFlag = createSelector(
  selectCache,
  (cache: any) => cache.contactSupportFlag
);

export const selectSupportReqSubmitting = createSelector(
  selectCache,
  (cache: any) => cache.supportReqSubmitting
);

export const selectSupportRes = createSelector(
  selectCache,
  (cache: any) => cache.supportRes
);

export const selectSupportError = createSelector(
  selectCache,
  (cache: any) => cache.contactSupportError
);

export const selectUpdatingUser = createSelector(
  selectCache,
  (cache: any) => cache.updatingUser
);

export const selectAddressSearchSuggestion = createSelector(
  selectCache,
  (cache: any) => cache.addressSearchSuggestion
);

export const selectShowNotificationOptionsModal = createSelector(
  selectCache,
  (cache: any) => cache.showNotificationOptionsModal
);

// Temporary block - need to delete after Helix enabled
export const selectRemedyForceClient = createSelector(
  selectCache,
  (cache: any) => cache.remedyForceClient
);
// Temporary block
